import React from '../_snowpack/pkg/react.js';
import PropTypes from '../_snowpack/pkg/prop-types.js';
export const TestTarget = ({
  children,
  name,
  ...props
}) => {
  return React.Children.map(children, child => /*#__PURE__*/React.cloneElement(child, { ...props,
    'data-testtarget': name
  }));
};
TestTarget.propTypes = {
  name: PropTypes.string.isRequired
};